import { Component, inject, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-mdl-change-task-owner',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './mdl-change-task-owner.html',
  styleUrls: ['./mdl-change-task-owner.css']
})
export class MdlChangeTaskOwner implements OnInit {
  ejecutivos: any[] = [];
  selectedOwner: string = '';
  isLoading: boolean = false;
  
  private api = inject(Api);

  constructor(
    public dialogRef: MatDialogRef<MdlChangeTaskOwner>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.cargarEjecutivos();
  }

  cargarEjecutivos() {
    this.isLoading = true;
    this.api.getUsers().subscribe({
      next: (response: any) => {
        console.log('Respuesta de usuarios:', response);
        
        let usuarios = response;
        
        if (Array.isArray(response)) {
          usuarios = response;
        } else if (response && Array.isArray(response.users)) {
          usuarios = response.users;
        } else if (response && Array.isArray(response.usuarios)) {
          usuarios = response.usuarios;
        } else if (response && Array.isArray(response.data)) {
          usuarios = response.data;
        }
        
        this.ejecutivos = usuarios
          .filter((user: any) => user.activo === 1 || user.activo === true || user.activo === undefined)
          .map((user: any) => ({
            valor: user.usuario_id || user.id,
            nombre: `${user.nombre || ''} ${user.apellido || ''}`.trim()
          }));
        
        console.log('Ejecutivos cargados:', this.ejecutivos);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error cargando ejecutivos:', error);
        this.isLoading = false;
        this.ejecutivos = [
          { valor: '1', nombre: 'Usuario Demo 1' },
          { valor: '2', nombre: 'Usuario Demo 2' }
        ];
      }
    });
  }

  changeOwner() {
    if (!this.selectedOwner) {
      alert('Por favor selecciona un propietario');
      return;
    }

    this.api.showLoading();
    
    let payload: any;

    if (this.data.mode === 'single' && this.data.taskId) {
      payload = {
        tarea_id: this.data.taskId,
        nuevo_propietario_id: this.selectedOwner
      };
      this.cambiarPropietario(payload);
    } 
    else if (this.data.mode === 'multiple' && this.data.taskIds) {
      payload = {
        tarea_ids: this.data.taskIds,
        nuevo_propietario_id: this.selectedOwner
      };
      this.cambiarPropietarioMultiples(payload);
    }
  }

  cambiarPropietario(payload: any) {
    console.log('Cambiando propietario individual:', payload);
    
    this.api.changeTaskOwner(payload).subscribe({
      next: (response: any) => {
        console.log('Propietario cambiado - Respuesta:', response);
        setTimeout(() => {
          this.api.hideLoading();
          this.dialogRef.close({ 
            success: true, 
            message: response.message || 'Propietario cambiado exitosamente'
          });
        }, 1000);
      },
      error: (error: any) => {
        console.error('Error cambiando propietario:', error);
        this.api.hideLoading();
        let errorMessage = 'Error al cambiar el propietario';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        }
        this.dialogRef.close({ 
          success: false, 
          message: errorMessage 
        });
      }
    });
  }

  cambiarPropietarioMultiples(payload: any) {
    console.log('Cambiando propietario múltiple:', payload);
    
    this.api.changeTaskOwner(payload).subscribe({
      next: (response: any) => {
        console.log('Propietarios cambiados - Respuesta:', response);
        setTimeout(() => {
          this.api.hideLoading();
          this.dialogRef.close({ 
            success: true, 
            tareasActualizadas: response.affected,
            message: response.message || `${response.affected} tareas actualizadas`
          });
        }, 1000);
      },
      error: (error: any) => {
        console.error('Error cambiando propietarios múltiples:', error);
        this.api.hideLoading();
        let errorMessage = 'Error al cambiar los propietarios';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        }
        this.dialogRef.close({ 
          success: false, 
          message: errorMessage 
        });
      }
    });
  }

  closeMdl() {
    this.dialogRef.close(false);
  }
}